// extracted by mini-css-extract-plugin
export var pillWrapper = "_p4-0";
export var showOverflow = "_p4-1";